import { useEffect, useState } from 'react';
import { Heading, Text } from 'react-aria-components';
import logger from 'src/utils/logger';
import Modal from 'src/components/ui/Modal';
import Button from 'src/components/ui/Button';
import Dialog from 'src/components/ui/Dialog';

const VersionModal = ({ buildVersion }: { buildVersion: string }) => {
  const [showModal, setShowModal] = useState(false);

  logger.debug('Build version loaded', { buildVersion });

  const loadVersion = async () =>
    fetch('/version.txt', { cache: 'no-store' })
      .then((res) => res.text())
      .then((ver) => {
        const version = ver.trim();
        const isSameVersion = version.localeCompare(buildVersion.trim()) === 0;

        logger.debug('Latest version fetched', { version, isSameVersion });

        setShowModal(!isSameVersion);
      });

  useEffect(() => {
    loadVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!showModal) return null;

  return (
    <Modal
      className="max-w-[28rem]"
      isOpen
      size="small"
      isKeyboardDismissDisabled
    >
      <Dialog
        role="alertdialog"
        className="flex flex-col gap-4 items-center justify-center p-8"
      >
        <Heading
          slot="title"
          className="text-xl  text-surface-alt-75 font-bold text-center"
        >
          Application update available
        </Heading>
        <Text elementType="p" className="text-center text-surface-alt-90">
          We provide updates to keep your software up to date. Please update for
          latest Student Center features.
        </Text>
        <Button
          // This non-dismissible alert appeared asynchronously; focus its only available action.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          onPress={() => {
            const { href } = window.location;
            window.location.href = href;
          }}
        >
          Update
        </Button>
      </Dialog>
    </Modal>
  );
};

export default VersionModal;
